import { jsx as _jsx } from "react/jsx-runtime";
import { SpecraButton } from '@mono/ui-components/ensigns';
import { Testids } from '@mono/ui-selectors';
import { useState } from 'react';
import { AddHearsayDialog } from '../../hearsay/AddHearsayDialog';
import { useIntelClaims } from '../../hearsay/hooks';
import { intelClaimsSection } from '../../hearsay/IntelClaimsRailSection';
/**
 * Plugs REG-03's hearsay kit into the Person page (REG-11 slots): claims about
 * this contact in the rail, "Add hearsay" in the header. Every claim the
 * server returns is one the viewer may see (author, or hearsay.read ceiling
 * AND the claim's audience); the FE never re-implements the rule.
 */ export function useContactHearsay(contactId, contactName) {
    const [open, setOpen] = useState(false);
    const query = useIntelClaims({
        kind: 'CONTACT',
        id: contactId
    });
    const claims = query.data?.claims ?? [];
    const canCreate = query.data?.canCreate ?? false;
    const section = intelClaimsSection(claims, {
        canCreate: false,
        onAdd: ()=>setOpen(true)
    });
    return {
        addAction: canCreate ? /*#__PURE__*/ _jsx(SpecraButton, {
            variant: "secondary",
            size: "sm",
            onClick: ()=>setOpen(true),
            "data-testid": Testids.registryHearsay.addButton,
            children: "Add hearsay"
        }) : null,
        claims: claims.length > 0 ? section.children : undefined,
        dialog: /*#__PURE__*/ _jsx(AddHearsayDialog, {
            open: open,
            onOpenChange: setOpen,
            defaultLinks: [
                {
                    linkRole: 'ABOUT',
                    targetKind: 'CONTACT',
                    targetId: contactId,
                    label: contactName,
                    locked: true
                }
            ],
            canCreateKinds: query.data?.canCreateKinds
        })
    };
}
